module.exports = __webpack_public_path__ + "img/logo.54db279a.png";